function getBaseUrlHostname() {
  const { hostname, protocol, port } = window.location;
  const hostnameParts = hostname.split(".");
  hostnameParts[0] = hostnameParts[0].replace("web", "");
  const newHostname = hostnameParts.join(".");
  return `${protocol}//${newHostname}:${port}`;
}

export default getBaseUrlHostname;



// WEBPACK FOOTER //
// ./src/utils/getBaseUrlHostname.js